import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileContactBar from './MobileContactBar';
import { initAutoTracking } from '../lib/analytics';

const Layout = ({ children }) => {
  // Jedno globalne nasluchiwanie klikniec zamiast handlera przy kazdym linku:
  // telefon, e-mail, mapa, trasa, PDF i CTA raportuja sie same (spec sekcja 24).
  useEffect(() => {
    initAutoTracking();
  }, []);

  return (
    <div>
      <Header />
      <main id="main">{children}</main>
      <Footer />
      <MobileContactBar />
    </div>
  );
};

export default Layout;
